export const GET_RECENTLY_ADDED_USERS = 'GET_RECENTLY_ADDED_USERS'
export const GET_RECENTLY_UPDATED_USERS = 'GET_RECENTLY_UPDATED_USERS'
export const GET_PENDING_USERS = 'GET_PENDING_USERS'
